/**
 * Builds a URL query string from a flat params object, skipping `undefined`
 * and `false` values so callers can pass optional flags straight through
 * without each call site filtering them out first.
 */
export function buildQueryString(
  params: Record<string, string | number | boolean | undefined>,
): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === false) continue;
    search.set(key, value === true ? '1' : String(value));
  }
  const query = search.toString();
  return query ? `?${query}` : '';
}
